// extracted by mini-css-extract-plugin
module.exports = {"title":"SetUsernameDialog_title_1ki0E","content":"SetUsernameDialog_content_YhOlR","submit":"SetUsernameDialog_submit_XW4CR"};